import { gql } from 'graphql-request'

const getArticleTopicDetails = gql`
  query getArticleTopicBySlug(
    $slug: String
    $lang: [Locale!]!
    $assetLocales: [Locale!]!
  ) {
    articleTopics(where: { slug: $slug }, locales: $lang) {
      id
      title
      subline
      text
      image(locales: $assetLocales) {
        og: url(
          transformation: {
            image: { resize: { width: 1200, height: 630, fit: crop } }
          }
        )
      }
      seo {
        metaTitle
        metaDescription
        ogImage(locales: $assetLocales) {
          src: url(
            transformation: {
              image: { resize: { width: 1200, height: 630, fit: crop } }
            }
          )
        }
        noIndex
      }
      localizations(includeCurrent: true) {
        slug
        locale
      }
      items: article(where: { title_not: "" }) {
        id
        title
        link: slug
        fullText: content {
          text
        }
        text: excerpt
        image(locales: $assetLocales) {
          alt
          src: url(
            transformation: {
              image: { resize: { width: 430, height: 275, fit: crop } }
            }
          )
          src_webp: url(
            transformation: {
              image: { resize: { width: 430, height: 275, fit: crop } }
              document: { output: { format: webp } }
            }
          )
          caption
        }

        tags {
          title
          id
        }
      }
      parentPage {
        slug
        title
      }
      parentTopic {
        slug
        title
      }
      featuredArticles {
        id
        slug
        title
        excerpt
        image {
          url(transformation: { document: { output: { format: webp } } })
        }
      }
      elements {
        ... on PageTeaser {
          id
          title
          subline
          type: __typename
          variant: type
          text {
            html
          }
          linkText {
            id
            text
          }
          link {
            ... on Page {
              id
              url: slug
              type: __typename
            }
            ... on Link {
              id
              url
              title
              linkTarget
              type: __typename
            }
            ... on ArticleTopic {
              id
              url: slug
              items: article {
                id
              }
            }
          }
          image(locales: $assetLocales) {
            src: url(
              transformation: {
                image: { resize: { width: 600, height: 400, fit: crop } }
              }
            )
            src_webp: url(
              transformation: {
                image: { resize: { width: 600, height: 400, fit: crop } }
                document: { output: { format: webp } }
              }
            )
            alt
            locale
          }
          articles {
            id
            reactions
            slug
            tags {
              title
            }
            title
            image {
              alt
              url(transformation: { document: { output: { format: webp } } })
            }
            topics {
              slug
              title
            }
          }
          reels {
            ... on InstagramReel {
              id
              linkInstagram {
                linkTarget
                title
                url
              }
              video {
                url
              }
            }
          }
        }
        ... on PageCallToAction {
          id
          title
          text
          smallText
          type: __typename
          buttonText {
            text
          }
          button: link {
            ... on Link {
              url
            }
          }
          visibility
        }
        ... on PageTextBanner {
          id
          type: __typename
          locale
          textSide
          title
          content
          headline
          image {
            url(
              transformation: {
                image: { resize: { fit: clip, height: 500, width: 1220 } }
                document: { output: { format: webp } }
              }
            )
          }
          primaryButtonLink {
            title
            url
            linkTarget
          }
          textLink {
            linkTarget
            title
            url
          }
          anchorId {
            value
          }
        }
        ... on PageTextImage {
          id
          type: __typename
          locale
          textSide
          content {
            html
          }
          image {
            url(
              transformation: {
                image: { resize: { fit: clip, height: 800, width: 800 } }
                document: { output: { format: webp } }
              }
            )
          }
          buttonLink {
            title
            url
            linkTarget
          }
          anchorId {
            value
          }
          titleText: title
          boxedLayout
          textLink {
            title
            url
            linkTarget
          }
        }
      }
    }
  }
`
export default getArticleTopicDetails
